// Canonical Flow Builder field catalog. Every path in the variable picker,
// condition editor, and condition-node catalog comes from this table and must
// resolve through PipelineAutomations::VariableResolver at runtime.

const variable = (
  token,
  labelKey,
  conditionType = null,
  catalogLabelKey = null
) => ({ token, labelKey, conditionType, catalogLabelKey });

export const FLOW_VARIABLES = {
  CONTACT_NAME: variable(
    'contact.name',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CONTACT_NAME',
    'string'
  ),
  CONTACT_EMAIL: variable(
    'contact.email',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CONTACT_EMAIL',
    'string'
  ),
  CONTACT_PHONE: variable(
    'contact.phone_number',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CONTACT_PHONE',
    'string'
  ),
  CONTACT_IDENTIFIER: variable(
    'contact.identifier',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CONTACT_IDENTIFIER'
  ),
  CONTACT_ID: variable(
    'contact.id',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CONTACT_ID'
  ),
  CONVERSATION_ID: variable(
    'conversation.id',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CONV_ID'
  ),
  CONVERSATION_DISPLAY_ID: variable(
    'conversation.display_id',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CONV_DISPLAY_ID'
  ),
  CONVERSATION_STATUS: variable(
    'conversation.status',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CONV_STATUS',
    'enum_status',
    'PIPELINE.FLOW_BUILDER.NODE.CONDITION.STATUS'
  ),
  CONVERSATION_PRIORITY: variable(
    'conversation.priority',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CONV_PRIORITY',
    'enum_priority',
    'PIPELINE.FLOW_BUILDER.NODE.CONDITION.PRIORITY'
  ),
  CONVERSATION_SUBJECT: variable(
    'conversation.subject',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CONV_SUBJECT'
  ),
  CONVERSATION_ASSIGNEE_ID: variable(
    'conversation.assignee_id',
    'PIPELINE.FLOW_BUILDER.EDITOR.CONDITION_CONV_ASSIGNEE',
    'agent',
    'PIPELINE.FLOW_BUILDER.NODE.CONDITION.ASSIGNEE'
  ),
  CONVERSATION_TEAM_ID: variable(
    'conversation.team_id',
    'PIPELINE.FLOW_BUILDER.EDITOR.CONDITION_CONV_TEAM',
    'team',
    'PIPELINE.FLOW_BUILDER.NODE.CONDITION.TEAM'
  ),
  CONVERSATION_LABEL_LIST: variable(
    'conversation.label_list',
    'PIPELINE.FLOW_BUILDER.EDITOR.CONDITION_CONV_LABEL',
    'enum_set',
    'PIPELINE.FLOW_BUILDER.NODE.CONDITION.LABEL_FIELD'
  ),
  INBOX_CHANNEL_TYPE: variable(
    'inbox.channel_type',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_INBOX_CHANNEL_TYPE',
    'channel',
    'PIPELINE.FLOW_BUILDER.NODE.CONDITION.CHANNEL'
  ),
  MESSAGE_CONTENT: variable(
    'message.content',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_MESSAGE_CONTENT',
    'string',
    'PIPELINE.FLOW_BUILDER.NODE.CONDITION.MESSAGE'
  ),
  MESSAGE_TYPE: variable(
    'message.message_type',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_MESSAGE_TYPE'
  ),
  MESSAGE_SENDER_TYPE: variable(
    'message.sender_type',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_MESSAGE_SENDER_TYPE'
  ),
  MESSAGE_CREATED_AT: variable(
    'message.created_at',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_MESSAGE_CREATED_AT'
  ),
  CARD_ID: variable('card.id', 'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CARD_ID'),
  CARD_TITLE: variable(
    'card.title',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CARD_TITLE'
  ),
  CARD_STAGE: variable(
    'card.pipeline_stage',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CARD_STAGE'
  ),
  CARD_REVENUE: variable(
    'card.expected_revenue',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CARD_VALUE'
  ),
  CARD_PRIORITY: variable(
    'card.priority',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CARD_PRIORITY'
  ),
  CARD_OWNER_ID: variable(
    'card.owner_id',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CARD_OWNER_ID'
  ),
  AGENT_NAME: variable(
    'agent.name',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_AGENT_NAME'
  ),
  AGENT_EMAIL: variable(
    'agent.email',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_AGENT_EMAIL'
  ),
  ACCOUNT_NAME: variable(
    'account.name',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_ACCOUNT_NAME'
  ),
  ACCOUNT_ID: variable(
    'account.id',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_ACCOUNT_ID'
  ),
  NOW_DATE: variable('now.date', 'PIPELINE.FLOW_BUILDER.EDITOR.VAR_NOW_DATE'),
  NOW_TIME: variable('now.time', 'PIPELINE.FLOW_BUILDER.EDITOR.VAR_NOW_TIME'),
  NOW_DATETIME: variable(
    'now.datetime',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_NOW_DATETIME'
  ),
  NOW_DAY: variable('now.day', 'PIPELINE.FLOW_BUILDER.EDITOR.VAR_NOW_DAY'),
  NOW_MONTH: variable(
    'now.month',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_NOW_MONTH'
  ),
  NOW_YEAR: variable('now.year', 'PIPELINE.FLOW_BUILDER.EDITOR.VAR_NOW_YEAR'),
  APPOINTMENT_TITLE: variable(
    'appointment.title',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_APPOINTMENT_TITLE'
  ),
  APPOINTMENT_SCHEDULED_AT: variable(
    'appointment.scheduled_at',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_APPOINTMENT_SCHEDULED_AT'
  ),
  APPOINTMENT_DURATION: variable(
    'appointment.duration_minutes',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_APPOINTMENT_DURATION'
  ),
  APPOINTMENT_STATUS: variable(
    'appointment.status',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_APPOINTMENT_STATUS'
  ),
  LEAD_SCORE_VALUE: variable(
    'lead_score.value',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_LEAD_SCORE_VALUE'
  ),
  LEAD_SCORE_THRESHOLD: variable(
    'lead_score.threshold',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_LEAD_SCORE_THRESHOLD'
  ),
  LEAD_SCORE_DELTA: variable(
    'lead_score.delta',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_LEAD_SCORE_DELTA'
  ),
  SLA_POLICY_NAME: variable(
    'sla.policy_name',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_SLA_POLICY_NAME'
  ),
  SLA_MINUTES_OVERDUE: variable(
    'sla.minutes_overdue',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_SLA_MINUTES_OVERDUE'
  ),
  SLA_THRESHOLD_MINUTES: variable(
    'sla.threshold_minutes',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_SLA_THRESHOLD_MINUTES'
  ),
  CAPTAIN_INTENT: variable(
    'captain.intent',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CAPTAIN_INTENT'
  ),
  CAPTAIN_CONFIDENCE: variable(
    'captain.confidence',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CAPTAIN_CONFIDENCE'
  ),
  CAPTAIN_ASSISTANT_ID: variable(
    'captain.assistant_id',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CAPTAIN_ASSISTANT_ID'
  ),
  WEBHOOK_PAYLOAD: variable(
    'webhook_payload',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_WEBHOOK_PAYLOAD'
  ),
  WEBHOOK_PAYLOAD_FIELD: variable(
    'webhook_payload.email',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_WEBHOOK_PAYLOAD_FIELD'
  ),
  CUSTOM_VARIABLE: variable(
    'variables.X',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CUSTOM_VARIABLE'
  ),
  RESPONSE_PAYLOAD: variable(
    'response_payload',
    'PIPELINE.FLOW_BUILDER.EDITOR.VAR_RESPONSE_PAYLOAD'
  ),
};

const CONTACT_TOKENS = [
  FLOW_VARIABLES.CONTACT_NAME,
  FLOW_VARIABLES.CONTACT_EMAIL,
  FLOW_VARIABLES.CONTACT_PHONE,
  FLOW_VARIABLES.CONTACT_IDENTIFIER,
  FLOW_VARIABLES.CONTACT_ID,
];
const CONVERSATION_TOKENS = [
  FLOW_VARIABLES.CONVERSATION_ID,
  FLOW_VARIABLES.CONVERSATION_DISPLAY_ID,
  FLOW_VARIABLES.CONVERSATION_STATUS,
  FLOW_VARIABLES.CONVERSATION_PRIORITY,
  FLOW_VARIABLES.CONVERSATION_SUBJECT,
  FLOW_VARIABLES.CONVERSATION_ASSIGNEE_ID,
  FLOW_VARIABLES.CONVERSATION_TEAM_ID,
  FLOW_VARIABLES.CONVERSATION_LABEL_LIST,
];
const MESSAGE_TOKENS = [
  FLOW_VARIABLES.MESSAGE_CONTENT,
  FLOW_VARIABLES.MESSAGE_TYPE,
  FLOW_VARIABLES.MESSAGE_SENDER_TYPE,
  FLOW_VARIABLES.MESSAGE_CREATED_AT,
];
const CARD_TOKENS = [
  FLOW_VARIABLES.CARD_ID,
  FLOW_VARIABLES.CARD_TITLE,
  FLOW_VARIABLES.CARD_STAGE,
  FLOW_VARIABLES.CARD_REVENUE,
  FLOW_VARIABLES.CARD_PRIORITY,
  FLOW_VARIABLES.CARD_OWNER_ID,
];
const AGENT_TOKENS = [FLOW_VARIABLES.AGENT_NAME, FLOW_VARIABLES.AGENT_EMAIL];
const INBOX_TOKENS = [FLOW_VARIABLES.INBOX_CHANNEL_TYPE];
const ACCOUNT_TOKENS = [FLOW_VARIABLES.ACCOUNT_NAME, FLOW_VARIABLES.ACCOUNT_ID];
const TIME_TOKENS = [
  FLOW_VARIABLES.NOW_DATE,
  FLOW_VARIABLES.NOW_TIME,
  FLOW_VARIABLES.NOW_DATETIME,
  FLOW_VARIABLES.NOW_DAY,
  FLOW_VARIABLES.NOW_MONTH,
  FLOW_VARIABLES.NOW_YEAR,
];
const APPOINTMENT_TOKENS = [
  FLOW_VARIABLES.APPOINTMENT_TITLE,
  FLOW_VARIABLES.APPOINTMENT_SCHEDULED_AT,
  FLOW_VARIABLES.APPOINTMENT_DURATION,
  FLOW_VARIABLES.APPOINTMENT_STATUS,
];
const LEAD_SCORE_TOKENS = [
  FLOW_VARIABLES.LEAD_SCORE_VALUE,
  FLOW_VARIABLES.LEAD_SCORE_THRESHOLD,
  FLOW_VARIABLES.LEAD_SCORE_DELTA,
];
const SLA_TOKENS = [
  FLOW_VARIABLES.SLA_POLICY_NAME,
  FLOW_VARIABLES.SLA_MINUTES_OVERDUE,
  FLOW_VARIABLES.SLA_THRESHOLD_MINUTES,
];
const CAPTAIN_TOKENS = [
  FLOW_VARIABLES.CAPTAIN_INTENT,
  FLOW_VARIABLES.CAPTAIN_CONFIDENCE,
  FLOW_VARIABLES.CAPTAIN_ASSISTANT_ID,
];
const WEBHOOK_TOKENS = [
  FLOW_VARIABLES.WEBHOOK_PAYLOAD,
  FLOW_VARIABLES.WEBHOOK_PAYLOAD_FIELD,
];
const VARIABLES_TOKENS = [
  FLOW_VARIABLES.CUSTOM_VARIABLE,
  FLOW_VARIABLES.RESPONSE_PAYLOAD,
];

const CONTEXT_TO_TOKENS = {
  contact: CONTACT_TOKENS,
  contact_optional: CONTACT_TOKENS,
  conversation: CONVERSATION_TOKENS,
  conversation_optional: CONVERSATION_TOKENS,
  message: MESSAGE_TOKENS,
  card: CARD_TOKENS,
  card_optional: CARD_TOKENS,
  appointment: APPOINTMENT_TOKENS,
  lead_score: LEAD_SCORE_TOKENS,
  sla: SLA_TOKENS,
  captain: CAPTAIN_TOKENS,
  webhook_payload: WEBHOOK_TOKENS,
};

const group = (groupName, labelKey, tokens) => ({
  group: groupName,
  labelKey,
  tokens,
});

export const getAvailableTokens = (contexts = []) => {
  const groups = [
    group(
      'variables',
      'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CAT_ALWAYS',
      VARIABLES_TOKENS
    ),
    group(
      'account',
      'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CAT_ACCOUNT',
      ACCOUNT_TOKENS
    ),
    group('time', 'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CAT_TIME', TIME_TOKENS),
  ];
  const contextSet = new Set(contexts);

  if (contextSet.has('contact') || contextSet.has('contact_optional')) {
    const labelKey = contextSet.has('contact_optional')
      ? 'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CAT_CONTACT_OPTIONAL'
      : 'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CAT_CONTACT';
    groups.push(group('contact', labelKey, CONTACT_TOKENS));
  }
  if (
    contextSet.has('conversation') ||
    contextSet.has('conversation_optional')
  ) {
    const labelKey = contextSet.has('conversation_optional')
      ? 'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CAT_CONVERSATION_OPTIONAL'
      : 'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CAT_CONVERSATION';
    groups.push(
      group('conversation', labelKey, CONVERSATION_TOKENS),
      group(
        'agent',
        'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CAT_AGENT',
        AGENT_TOKENS
      ),
      group('inbox', 'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CAT_INBOX', INBOX_TOKENS)
    );
  }
  if (contextSet.has('message')) {
    groups.push(
      group(
        'message',
        'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CAT_MESSAGE',
        MESSAGE_TOKENS
      )
    );
  }
  if (contextSet.has('card') || contextSet.has('card_optional')) {
    const labelKey = contextSet.has('card_optional')
      ? 'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CAT_PIPELINE_OPTIONAL'
      : 'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CAT_PIPELINE';
    groups.push(group('card', labelKey, CARD_TOKENS));
  }
  if (contextSet.has('appointment')) {
    groups.push(
      group(
        'appointment',
        'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CAT_APPOINTMENT',
        APPOINTMENT_TOKENS
      )
    );
  }
  if (contextSet.has('lead_score')) {
    groups.push(
      group(
        'lead_score',
        'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CAT_LEAD_SCORE',
        LEAD_SCORE_TOKENS
      )
    );
  }
  if (contextSet.has('sla')) {
    groups.push(
      group('sla', 'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CAT_SLA', SLA_TOKENS)
    );
  }
  if (contextSet.has('captain')) {
    groups.push(
      group(
        'captain',
        'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CAT_CAPTAIN',
        CAPTAIN_TOKENS
      )
    );
  }
  if (contextSet.has('webhook_payload')) {
    groups.push(
      group(
        'webhook',
        'PIPELINE.FLOW_BUILDER.EDITOR.VAR_CAT_WEBHOOK',
        WEBHOOK_TOKENS
      )
    );
  }

  return groups;
};

export const CONDITION_FIELD_GROUPS = [
  {
    group: 'contact',
    labelKey: 'PIPELINE.FLOW_BUILDER.EDITOR.CONDITION_GROUP_CONTACT',
    fields: [
      FLOW_VARIABLES.CONTACT_NAME,
      FLOW_VARIABLES.CONTACT_EMAIL,
      FLOW_VARIABLES.CONTACT_PHONE,
    ],
  },
  {
    group: 'conversation',
    labelKey: 'PIPELINE.FLOW_BUILDER.EDITOR.CONDITION_GROUP_CONVERSATION',
    fields: [
      FLOW_VARIABLES.CONVERSATION_STATUS,
      FLOW_VARIABLES.CONVERSATION_PRIORITY,
      FLOW_VARIABLES.CONVERSATION_ASSIGNEE_ID,
      FLOW_VARIABLES.CONVERSATION_TEAM_ID,
      FLOW_VARIABLES.CONVERSATION_LABEL_LIST,
      FLOW_VARIABLES.INBOX_CHANNEL_TYPE,
    ],
  },
  {
    group: 'message',
    labelKey: 'PIPELINE.FLOW_BUILDER.EDITOR.CONDITION_GROUP_MESSAGE',
    fields: [FLOW_VARIABLES.MESSAGE_CONTENT],
  },
];

export const CONDITION_FIELD_TYPES = Object.fromEntries(
  CONDITION_FIELD_GROUPS.flatMap(fieldGroup => fieldGroup.fields).map(field => [
    field.token,
    field.conditionType,
  ])
);

export const CATALOG_CONDITION_FIELDS = [
  { field: FLOW_VARIABLES.CONVERSATION_STATUS, operator: 'equals' },
  { field: FLOW_VARIABLES.CONVERSATION_PRIORITY, operator: 'equals' },
  { field: FLOW_VARIABLES.MESSAGE_CONTENT, operator: 'contains' },
  { field: FLOW_VARIABLES.CONVERSATION_ASSIGNEE_ID, operator: 'equals' },
  { field: FLOW_VARIABLES.CONVERSATION_TEAM_ID, operator: 'equals' },
  { field: FLOW_VARIABLES.CONVERSATION_LABEL_LIST, operator: 'equals' },
  { field: FLOW_VARIABLES.INBOX_CHANNEL_TYPE, operator: 'equals' },
];

export const wrapToken = token => `{{ ${token} }}`;

export const TOKEN_GROUPS = {
  CONTACT_TOKENS,
  CONVERSATION_TOKENS,
  MESSAGE_TOKENS,
  CARD_TOKENS,
  AGENT_TOKENS,
  INBOX_TOKENS,
  ACCOUNT_TOKENS,
  TIME_TOKENS,
  APPOINTMENT_TOKENS,
  LEAD_SCORE_TOKENS,
  SLA_TOKENS,
  CAPTAIN_TOKENS,
  WEBHOOK_TOKENS,
  VARIABLES_TOKENS,
};
export const CONTEXT_MAP = CONTEXT_TO_TOKENS;
